const statusModule = {
  payStatus0: "미지급",
  payStatus1: "지급완료",
  payStatus3: "환불성공",
  payStatus4: "환불실패",
  "orderStatus-1": "취소됨",
  orderStatus0: "대기 처리",
  orderStatus1: "확인됨",
  orderStatus2: "완성",
  orderAll: "전부",
  payFun3: "현금지불",
  payFun3_1: "현금지불",
  Monday: "월요일",
  Tuesday: "화요일",
  Wednesday: "수요일",
  Thursday: "목요일",
  Friday: "금요일",
  Saturday: "토요일",
  Sunday: "일요일",
  zhuri: '축 일',
  sex0: "비밀",
  sex1: "남자",
  sex2: "여자",
  loading: "로딩 중",
  noMore: "더 이상 없습니다",
  feedbackType0: "주문에 관하여",
  feedbackType1: "회원정보에 관하여",
  feedbackType2: "사용 방법에 관하여",
  feedbackType3: "기타",
  payType1: "위챗 페이",
  payType2: "알리페이",
  payType3: "신용카드 결제"
};
export default statusModule;
